(function (window, document) {
  "use strict";

  const cardHolder = document.getElementById("card-holder");
  const searchField = document.getElementById("searchField");
  const pressEnter = (e) => {
    if (e.key === "Enter") {
      searchField && searchField.blur();
    }
  };
  const search = (e) => {
    if (e.target.value) {
      cardHolder.style.display = "none";
    }
    const results = window.searchIndex.search(e.target.value, {
      bool: "AND",
      expand: true,
    });

    const resEl = document.getElementById("searchResults");
    const noResultsEl = document.getElementById("noResultsFound");

    resEl.innerHTML = "";
    if (Object.keys(results).length !== 0) {
      noResultsEl.style.display = "none";
      cardHolder.style.display = "none";
      results.map((r) => {
        const { id, title, categories, excerpt, date } = r.doc;
        const el = document.createElement("div");
        el.setAttribute(
          "class",
          "archive-card card border border-light shadow-0"
        );
        el.style.display = "flex";

        resEl.appendChild(el);

        const header = document.createElement("div");
        header.setAttribute("id", "archive-header");
        header.setAttribute("class", "card-header border-0");
        el.appendChild(header);

        const h3 = document.createElement("h3");
        h3.setAttribute("class", "card-title pb-3");
        h3.style.textDecoration = "underline";
        header.appendChild(h3);

        const a = document.createElement("a");
        a.setAttribute("href", id);
        a.setAttribute("class", "text-black");
        a.textContent = title;

        h3.appendChild(a);

        const dateSection = document.createElement("div");
        dateSection.setAttribute("class", "category-section text-muted");
        var dateString = date;
        dateSection.innerHTML += dateString;
        header.appendChild(dateSection);

        console.log(categories);

        var catString = "";
        if(categories.length === 1) {
            catString = `&nbsp; &nbsp;[<a href="/category/${categories[0].replaceAll(' ', '-')}">${categories[0]}</a>]`;
        } else {
            for (let i = 0; i < categories.length; i++) {
              if (i === 0) {
                catString += `&nbsp; &nbsp;[<a href="/category/${categories[i].split(' ').join('-')}">${categories[i]}</a>, `;
              } else if (i != categories.length - 1) {
                catString += `<a href="/category/${categories[i].split(' ').join('-')}">${categories[i]}</a>, `;
              } else {
                catString += `<a href="/category/${categories[i].split(' ').join('-')}">${categories[i]}</a>]`;
              }
            }
        }
        // header.innerHTML += catString;
        
        dateSection.innerHTML += catString;
        

        const cardBody = document.createElement("div");
        header.setAttribute("class", "card-body");
        el.appendChild(cardBody);
        const excerptP = document.createElement("p");
        excerptP.setAttribute("class", "card-text");
        excerptP.innerHTML += excerpt;
        cardBody.appendChild(excerptP);

      });
    } else {
      noResultsEl.style.display = "block";
      cardHolder.style.display = "block";
    }
  };

  fetch("/search-index.json").then((response) =>
    response.json().then((rawIndex) => {
      window.searchIndex = elasticlunr.Index.load(rawIndex);
      document.getElementById("searchField").addEventListener("keyup", search);
      document.getElementById("searchField").addEventListener("keydown", pressEnter);

    })
  );

})(window, document);
